import '../App.css';
import React, { useEffect, useState } from "react";
import { Form, Button, Spin } from 'antd';
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons"
import { useNavigate } from 'react-router-dom';
import QuestionCard from '../components/QuestionCard';
import { routes } from '../const';
import { baseUrl, isTask } from '../tasks';

export default function PostSurvey() {
    let navigate = useNavigate();

    const [ loading, setLoading ] = useState(true);
    const [ qns, setQns ] = useState([]);
    const [ tasks, setTasks ] = useState([]);
    const [ curr, setCurr ] = useState(1);
    const [ form ] = Form.useForm();

    const incrementCurr = () => {
        if (form.getFieldValue(qns[curr - 1].question) === undefined)
        {
            form.validateFields();
            return
        }
        if (curr < qns.length)
            setCurr(curr + 1);
    }

    const decrementCurr = () => {
        if (curr > 1)
            setCurr(curr - 1)
    }

    useEffect(() => {
        // activate spinner
        setLoading(true);
        const promises = []
        for (let i = 0; i < window.localStorage.length; i ++)
        {
            const task = window.localStorage.key(i);
            if (!isTask(task)) continue;
            // save promises
            promises.push(fetch(`${baseUrl}/api/postsurvey/${task}`)
                .then(response => response.ok ? response.json() : false)
                .then(data => {
                    if (data) {
                        return [task, data];
                    }
                    return false;
                })
            )
        }

        // wait for resolve and handle
        Promise.all(promises).then((values) => {
            const cQs = [];
            const cTs = [];
            for (const r of values) {
                if (r) {
                    cTs.push({task: r[0], length: r[1].length}); // task
                    cQs.push(...r[1]);
                }
            }
            setQns(cQs);
            setTasks(cTs);
            setLoading(false);
            return cQs;
        }).then((cQs) => {
            if (cQs.length === 0) navigate(routes.FIN);
        });
    }, []);

    const onFinish = (values) => {
        setLoading(true);
        const reqBody = {};
        const responses = [];
        const tasksArr = tasks.map((o) => o.task);
        reqBody["tasks"] = tasksArr;
        let i = 0;
        let tPointer = 0;
        for (const key of Object.keys(values))
        {
            const r = { task: tasksArr[tPointer], question: key, response: values[key] }
            responses.push(r);
            if (++i === tasks[tPointer].length) {
                i = 0;
                tPointer++;
            }
        }
        reqBody["responses"] = responses;

        fetch(`${baseUrl}/api/postsurvey`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(reqBody)
        });

        navigate(routes.FIN);
    };

    return (
        <Spin className="mx" size="large" tip="Loading..." spinning={loading}>
        <div className="mx-auto w-4/5">
            <Form form={form} name="postsurvey" onFinish={onFinish}>
                { qns.map((q, i) =>
                    <QuestionCard
                        key={i}
                        id={i+1}
                        question={q.question}
                        options={q.options}
                        curr={curr} /> )
                }
                <div className="flex flex-row items-start">
                    { curr > 1 && <ArrowLeftOutlined onClick={() => decrementCurr()}
                        className="text-6xl hover:text-green-900" /> }
                    { curr === qns.length ?
                        <Form.Item className="ml-auto">
                            <Button htmlType="submit" type="primary">Submit</Button>
                        </Form.Item> :
                        <ArrowRightOutlined onClick={() => incrementCurr()}
                            className="text-6xl hover:text-green-900 ml-auto" />
                    }
                </div>
            </Form>

        </div>
        </Spin>
    );
}